// extracted by mini-css-extract-plugin
export default {"loadingLink":"VerificationSmsCodeForm_loadingLink_lXMQ9"};